import { Link } from "react-router-dom";
import { theme } from "@/lib/theme";

const BG = theme.bg;
const HEADING = theme.heading;
const MUTED_TEXT = theme.mutedText;
const BORDER = theme.border;

export function SiteFooter() {
  return (
    <footer style={{ background: BG }} className="px-4 pb-6 pt-2 sm:px-6">
      <div
        className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 border-t pt-3 sm:flex-row"
        style={{ borderColor: BORDER }}
      >
        <p className="text-xs" style={{ color: MUTED_TEXT }}>
          Motosport Software, {new Date().getFullYear()}
        </p>
        <nav
          aria-label="Footer"
          className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 sm:gap-x-6"
        >
          <Link
            to="/contact"
            className="inline-flex min-h-[44px] items-center text-xs font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1F2A3A]"
            style={{ color: HEADING }}
          >
            Contact
          </Link>
          <Link
            to="/privacy"
            className="inline-flex min-h-[44px] items-center text-xs font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1F2A3A]"
            style={{ color: HEADING }}
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            className="inline-flex min-h-[44px] items-center text-xs font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1F2A3A]"
            style={{ color: HEADING }}
          >
            Terms
          </Link>
          <Link
            to="/dealer-code-of-conduct"
            className="inline-flex min-h-[44px] items-center text-xs font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1F2A3A]"
            style={{ color: HEADING }}
          >
            Dealer Code of Conduct
          </Link>
        </nav>
      </div>
    </footer>
  );
}
